import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "d-flex align-center mb-3"
};
const _hoisted_2 = {
  class: "col-60"
};
const _hoisted_3 = {
  class: "text-body-2 pl-12"
};
const _hoisted_4 = {
  class: "col-40"
};
const _hoisted_5 = {
  class: "d-flex align-center mb-3"
};
const _hoisted_6 = {
  class: "col-60"
};
const _hoisted_7 = {
  class: "text-body-2 pl-12"
};
const _hoisted_8 = {
  class: "col-40"
};
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-center mb-3"
};
const _hoisted_10 = {
  class: "col-40"
};
const _hoisted_11 = {
  key: 1,
  class: "d-flex align-center mb-3"
};
const _hoisted_12 = {
  class: "col-40"
};
const _hoisted_13 = {
  class: "d-flex align-center mb-3"
};
const _hoisted_14 = {
  key: 2,
  class: "d-flex align-center"
};
const _hoisted_15 = {
  class: "col-40"
};
const _hoisted_16 = {
  key: 3,
  class: "d-flex align-center"
};
const _hoisted_17 = {
  class: "col-40"
};
import LlTextField from '@/components/LlTextField.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'AllocationShare',
  props: {
    state: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    calculateTotalAutimatically();
    function calculateTotalAutimatically(contributionFirm, workingContribution) {
      if (props.state.form.useWorkingPercentage) {
        if (contributionFirm) {
          calculateWorkingContribution();
        } else {
          calculateOriginatingContribution();
        }
      } else {
        if (workingContribution) {
          calculateOriginatingContribution();
        } else {
          calculateWorkingContribution();
        }
      }
      props.state.calculateTotalAutimaticallyError = false;
      if (props.state.form.originatingContributionFirm < 0) {
        props.state.calculateTotalAutimaticallyError = true;
        props.alerts.error('The Firm Share cannot be Negative');
      }
      if (props.state.form.workingContribution < 0) {
        props.state.calculateTotalAutimaticallyError = true;
        props.alerts.error('The Working Attorney cannot be Negative');
      }
    }
    function reverseWorking() {
      props.state.form.useWorkingPercentage = !props.state.form.useWorkingPercentage;
    }
    function calculateWorkingContribution() {
      props.state.form.workingContribution = 100 - ((props.state.form.originatingContributionFirm || 0) + (props.state.form.originatingContribution || 0) + (props.state.form.responsibleContribution || 0));
    }
    function calculateOriginatingContribution() {
      props.state.form.originatingContributionFirm = 100 - ((props.state.form.workingContribution || 0) + (props.state.form.originatingContribution || 0) + (props.state.form.responsibleContribution || 0));
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "text-lg font-medium pb-4"
      }, "Revenue Allocation", -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("label", _hoisted_3, " Originating " + _toDisplayString(__props.state.me.terms.Lead) + " Share ", 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(LlTextField, {
        modelValue: __props.state.form.originatingContribution,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.state.form.originatingContribution = $event),
        modelModifiers: {
          number: true
        },
        type: "number",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        suffix: "%",
        onChange: _cache[1] || (_cache[1] = $event => calculateTotalAutimatically(__props.state.form.useWorkingPercentage ? (true, false) : (false, true)))
      }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("label", _hoisted_7, " Responsible " + _toDisplayString(__props.state.me.terms.Lead) + " Share ", 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(LlTextField, {
        modelValue: __props.state.form.responsibleContribution,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => __props.state.form.responsibleContribution = $event),
        modelModifiers: {
          number: true
        },
        type: "number",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        suffix: "%",
        onChange: _cache[3] || (_cache[3] = $event => calculateTotalAutimatically(__props.state.form.useWorkingPercentage ? (true, false) : (false, true)))
      }, null, 8, ["modelValue"])])]), !__props.state.form.useWorkingPercentage ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "d-flex align-center col-60"
      }, [_createElementVNode("div", {
        class: "decorative-top"
      }), _createElementVNode("label", {
        class: "text-body-2"
      }, "Firm Share")], -1)), _createElementVNode("div", _hoisted_10, [_createVNode(LlTextField, {
        modelValue: __props.state.form.originatingContributionFirm,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => __props.state.form.originatingContributionFirm = $event),
        modelModifiers: {
          number: true
        },
        type: "number",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        suffix: "%",
        onChange: _cache[5] || (_cache[5] = $event => calculateTotalAutimatically(true, false))
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), __props.state.form.useWorkingPercentage ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "d-flex align-center col-60"
      }, [_createElementVNode("div", {
        class: "decorative-top-small"
      }), _createElementVNode("label", {
        class: "text-body-2"
      }, "Working Attorney")], -1)), _createElementVNode("div", _hoisted_12, [_createVNode(LlTextField, {
        modelValue: __props.state.form.workingContribution,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => __props.state.form.workingContribution = $event),
        modelModifiers: {
          number: true
        },
        type: "number",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        suffix: "%",
        onChange: _cache[7] || (_cache[7] = $event => calculateTotalAutimatically(false, true))
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createVNode(LlSecondaryButton, {
        icon: "mdi-swap-horizontal",
        variant: "text",
        size: "small",
        color: "primary",
        "aria-label": "Swap which share is calculated",
        onClick: _cache[8] || (_cache[8] = _withModifiers($event => reverseWorking(), ["prevent"])),
        class: "-ml-5"
      }), _cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "pl-6 text-primary text-body-2 font-weight-medium"
      }, "Calculated Value", -1))]), !__props.state.form.useWorkingPercentage ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "d-flex align-center col-60"
      }, [_createElementVNode("div", {
        class: "decorative-bottom"
      }), _createElementVNode("label", {
        class: "text-body-2"
      }, "Working Attorney")], -1)), _createElementVNode("div", _hoisted_15, [_createVNode(LlTextField, {
        modelValue: __props.state.form.workingContribution,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => __props.state.form.workingContribution = $event),
        modelModifiers: {
          number: true
        },
        type: "number",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        suffix: "%",
        disabled: ""
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), __props.state.form.useWorkingPercentage ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "d-flex align-center col-60"
      }, [_createElementVNode("div", {
        class: "decorative-bottom"
      }), _createElementVNode("label", {
        class: "text-body-2"
      }, "Firm Share")], -1)), _createElementVNode("div", _hoisted_17, [_createVNode(LlTextField, {
        modelValue: __props.state.form.originatingContributionFirm,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => __props.state.form.originatingContributionFirm = $event),
        modelModifiers: {
          number: true
        },
        type: "number",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        suffix: "%",
        disabled: ""
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true)]);
    };
  }
};